import { Outlook, OutlookResultMethods } from './outlook';

export class OutlookDebug implements OutlookResultMethods {
  token: string;
  api: string;
  web: string;

  constructor(outlook: Outlook) {
    this.token = outlook.token;
    this.api = outlook.api;
    this.web = outlook.web;

    this.emails = [
      {
        emailAddress: 'mikecurliss@maximizer.com',
        displayName: 'Mike Curliss',
        recipientType: 'user',
      },
      {
        emailAddress: 'testeandre@andrekamp.com.br',
        displayName: 'Test Andre',
        recipientType: 'user',
      },
      {
        emailAddress: 'iainblack@maximizer.com',
        displayName: 'Iain Black',
        recipientType: 'user',
      },
      {
        emailAddress: 'BrianAdams@maximizer.com',
        displayName: 'Brian Adams',
        recipientType: 'user',
      },
      {
        emailAddress: 'developmentgroup@maximizer.com',
        displayName: '',
        recipientType: 'user',
      },
      {
        emailAddress: 'MercedesBook@maximizer.com',
        displayName: 'Mercedes Book',
        recipientType: 'user',
      },
      {
        emailAddress: 'alexandreackermans@maximizer.com',
        displayName: 'Alexandre Ackermans',
        recipientType: 'user',
      },
      {
        emailAddress: 'ColleenMachnikowski@maximizer.com',
        displayName: 'Colleen Machnikowski',
        recipientType: 'user',
      },
      {
        emailAddress: 'DanielHarkness@maximizer.com',
        displayName: 'Daniel Harkness',
        recipientType: 'user',
      },
      {
        emailAddress: 'DenisYuriev@maximizer.com',
        displayName: 'Denis Yuriev',
        recipientType: 'user',
      },
      {
        emailAddress: 'dlunardi@maximizer.co.uk',
        displayName: 'Diego Lunardi UK',
        recipientType: 'user',
      },
      {
        emailAddress: 'EmilyMottram@maximizer.com',
        displayName: 'Emily Mottram',
        recipientType: 'user',
      },
      {
        emailAddress: 'EstherKim@maximizer.com',
        displayName: 'Esther Kim',
        recipientType: 'user',
      },
      {
        emailAddress: 'GabeKarkanis@maximizer.com',
        displayName: 'Gabe Karkanis',
        recipientType: 'user',
      },
      {
        emailAddress: 'HanaGeara@maximizer.com',
        displayName: 'Hana Geara',
        recipientType: 'user',
      },
      {
        emailAddress: 'JaspreetDeol@maximizer.com',
        displayName: 'Jaspreet Deol',
        recipientType: 'user',
      },
      {
        emailAddress: 'JeffWest@maximizer.com',
        displayName: 'Jeff West',
        recipientType: 'user',
      },
      {
        emailAddress: 'Jonathan@learnmaximizer.com',
        displayName: 'Jonathan Wong',
        recipientType: 'user',
      },
      {
        emailAddress: 'jBreuer@maximizer.co.uk',
        displayName: 'Julia Breuer UK',
        recipientType: 'user',
      },
      {
        emailAddress: 'julianahazarika@maximizer.com',
        displayName: 'Juliana Hazarika',
        recipientType: 'user',
      },
      {
        emailAddress: 'KitChow@maximizer.com',
        displayName: 'Kit Chow',
        recipientType: 'user',
      },
      {
        emailAddress: 'LJQuirk@maximizer.com',
        displayName: 'LJ Quirk',
        recipientType: 'user',
      },
      {
        emailAddress: 'Product@maximizer.com',
        displayName: 'Product',
        recipientType: 'distributionList',
      },
      {
        emailAddress: 'robertwilson@maximizer.com',
        displayName: 'Robert Wilson',
        recipientType: 'user',
      },
      {
        emailAddress: 'RykielBterrani@maximizer.com',
        displayName: 'Rykiel Bterrani',
        recipientType: 'user',
      },
      {
        emailAddress: 'samanthafeerick@maximizer.com',
        displayName: 'Samantha Feerick UK',
        recipientType: 'user',
      },
      {
        emailAddress: 'Samantha@Maximizercrm.tech',
        displayName: 'Samantha Juett',
        recipientType: 'user',
      },
    ];

    this.data = {
      othersInMaximizer: [
        {
          displayName: '123 Andre',
          emailAddress: 'andreh.kamp1@gmail.com',
          type: 'lead',
          id: '123123',
        },
        {
          displayName: 'Jane Doe',
          emailAddress: 'jane.doe@example.com',
          type: 'lead',
          id: '456456',
        },
        {
          displayName: 'Charlie',
          emailAddress: 'charlie.brown@example.com',
          type: 'abentry',
          abentryType: 'individual',
          id: '789789',
        },
        {
          displayName: 'Ella',
          emailAddress: 'ella.johnson@example.com',
          type: 'lead',
          id: '101010',
        },
        {
          displayName: 'Henry',
          emailAddress: 'henry.thomas@example.com',
          type: 'lead',
          id: '111111',
        },
        {
          displayName: 'Olivia',
          emailAddress: 'olivia.williams@example.com',
          type: 'abentry',
          abentryType: 'individual',
          id: '121212',
        },
        {
          displayName: 'William',
          emailAddress: 'william.jones@example.com',
          type: 'lead',
          id: '131313',
        },
        {
          displayName: 'Ava',
          emailAddress: 'ava.martin@example.com',
          type: 'lead',
          id: '141414',
        },
        {
          displayName: 'Liam',
          emailAddress: 'liam.jackson@example.com',
          type: 'abentry',
          abentryType: 'individual',
          id: '151515',
        },
        {
          displayName: 'Mia',
          emailAddress: 'mia.rodriguez@example.com',
          type: 'lead',
          id: '161616',
        },
      ],
    };
  }
  saveEmails(emails: object[], isOtherEntries: boolean): boolean {
    return true;
  }
  goToPreviousPage!: (initPage: boolean) => void;
  notify!: (
    title: string,
    content?: string | undefined,
    isWarning?: boolean | undefined,
  ) => void;
  adjustIframe!: () => void;
  logout!: () => void;
  data?: object;
  emails?: {
    emailAddress: string;
    displayName: string;
    recipientType?: string;
  }[];
  createdId?: string;
  hideLoading?: () => void;
}
